import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import AnimatedPage from '../../components/AnimatedPage';
import {ButtonCircle, Page1Container, TextButton} from './page1.styled';
import {BackButton} from '../../components/BackButton';

const Page1 = () => {
  const [clickedButton, setClickedButton] = useState (null);
  const navigate = useNavigate ();

  const handleButtonClick = buttonId => {
    setClickedButton (buttonId);
    setTimeout (() => {
      setClickedButton (null);
      switch (buttonId) {
        case 'digibank':
          navigate ('/page1/digibank');
          break;
        case 'qrpay':
          navigate ('/page1/qrpay');
          break;
        case 'biometric':
          navigate ('/page1/biometric');
          break;
        case 'globalpay':
          navigate ('/page1/globalpay');
          break;
        case 'digisign':
          navigate ('/page1/digisign');
          break;
        default:
          break;
      }
    }, 300); // Reset after animation
  };

  return (
    <AnimatedPage animationType="fade">
      <Page1Container>
        <BackButton />
        <ButtonCircle
          isMain
          isClicked={clickedButton === 'digisign'}
          onClick={() => handleButtonClick ('digisign')}
        >
          <TextButton>
            CHỮ KÝ SỐ
          </TextButton>
        </ButtonCircle>
        <ButtonCircle
          width={430}
          height={430}
          top={940}
          left={343}
          rgb="rgb(24 255 0)"
          isClicked={clickedButton === 'digibank'}
          onClick={() => handleButtonClick ('digibank')}
        >
          <TextButton size={34}>
            NGÂN HÀNG SỐ
            <br />
            VCB DIGIBANK
          </TextButton>
        </ButtonCircle>
        <ButtonCircle
          width={430}
          height={430}
          top={1243}
          left={1180}
          rgb="rgb(24 255 0)"
          isClicked={clickedButton === 'biometric'}
          onClick={() => handleButtonClick ('biometric')}
        >
          <TextButton size={34}>
            SINH TRẮC HỌC
            <br />
            & VCB TABLET
          </TextButton>
        </ButtonCircle>
        <ButtonCircle
          width={430}
          height={430}
          top={1243}
          left={2835}
          rgb="rgb(24 255 0)"
          isClicked={clickedButton === 'globalpay'}
          onClick={() => handleButtonClick ('globalpay')}
        >
          <TextButton size={40}>
            GLOBAL
            <br />
            PAY
          </TextButton>
        </ButtonCircle>
        <ButtonCircle
          width={430}
          height={430}
          top={940}
          left={3683}
          rgb="rgb(24 255 0)"
          isClicked={clickedButton === 'qrpay'}
          onClick={() => handleButtonClick ('qrpay')}
        >
          <TextButton size={36}>
            QR
            <br />
            THANH TOÁN
            <br />
            XUYÊN
            <br />
            BIÊN GIỚI
          </TextButton>
        </ButtonCircle>
      </Page1Container>
    </AnimatedPage>
  );
};

export default Page1;
